import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import { makeStyles } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import Form from "@saleor/components/Form";
import Grid from "@saleor/components/Grid";
import {
  hasNoError,
  usePayoutValidation
} from "@saleor/utils/validators/payout";
import Moment from "moment";
import React, { useState } from "react";
import { FormattedMessage, useIntl } from "react-intl";

export interface PayoutScheduleDialogProps {
  open: any;
  onClose: any;
  onSubmit: any;
  payoutDataSchedule: any;
}
export interface PayoutFormData {
  payoutStartDate: string;
  payoutStartHour: string;
  payoutEndDate: string;
  payoutEndHour: string;
  scheduleDate: string;
  scheduleHour: string;
}

export interface PayoutFormValidation {
  payoutStartDate?: string;
  payoutEndDate?: string;
  scheduleDate?: string;
}
const useStyles = makeStyles(
  () => ({
    buttonActionFlex: {
      flexDirection: "column"
    },
    buttonActions: {
      display: "flex",
      width: "100%"
    },
    buttonWidth: {
      margin: "3px",
      width: "100%"
    },
    singleSelectField: {
      "& label": {
        overflowX: "visible",
        width: "100%"
      }
    },
    textBold: {
      "&:nth-child(1)": {
        marginTop: "0px"
      },
      fontSize: "14px",
      fontWeight: 600,
      margin: "12px 0px"
    }
  }),
  { name: "PayoutScheduleDialog" }
);

const PayoutScheduleDialog: React.SFC<PayoutScheduleDialogProps> = props => {
  const { onClose, open, onSubmit, payoutDataSchedule } = props;

  const classes = useStyles(props);
  const intl = useIntl();
  const container = React.useRef<HTMLDivElement>();
  // const disabled = payoutDataSchedule ? false : true;
  const [selectedStartDate, setSelectedStartDate] = React.useState(null);
  const [selectedStartHour, setSelectedStartHour] = React.useState("00:00");
  const [selectedEndDate, setSelectedEndDate] = React.useState(null);
  const [selectedEndHour, setSelectedEndHour] = React.useState("23:59");
  const [selectedScheduleDate, setSelectedScheduleDate] = React.useState(null);
  const [selectedScheduleHour, setSelectedScheduleHour] = React.useState(
    "00:00"
  );
  React.useEffect(() => {
    if (payoutDataSchedule && payoutDataSchedule.payoutScheduleLatest) {
      const {
        coverageDate,
        schedule
      } = payoutDataSchedule.payoutScheduleLatest;
      setSelectedStartDate(coverageDate.from);
      setSelectedEndDate(coverageDate.to);
      setSelectedScheduleDate(schedule);
    }
  }, [payoutDataSchedule]);

  const today = Moment(new Date()).format("YYYY-MM-DD");

  const handleSelectPayoutStartDate = event => {
    setSelectedStartDate(event.target.value);
  };

  const handleSelectPayoutStartHour = event => {
    setSelectedStartHour(event.target.value);
  };

  const handleSelectPayoutEndDate = event => {
    setSelectedEndDate(event.target.value);
  };

  const handleSelectPayoutEndHour = event => {
    setSelectedEndHour(event.target.value);
  };

  const handleSelectScheduleDate = event => {
    setSelectedScheduleDate(event.target.value);
  };

  const handleSelectScheduleTime = event => {
    setSelectedScheduleHour(event.target.value);
  };

  const initialForm: PayoutFormData = {
    payoutEndDate: selectedEndDate,
    payoutEndHour: selectedEndHour,
    payoutStartDate: selectedStartDate,
    payoutStartHour: selectedStartHour,
    scheduleDate: selectedScheduleDate,
    scheduleHour: selectedScheduleHour
  };

  const initalFormValidation: PayoutFormValidation = {
    payoutEndDate: null,
    payoutStartDate: null,
    scheduleDate: null
  };

  const [clientError, setErrorValdiation] = useState(initalFormValidation);

  const handleSubmit = event => {
    const validate = usePayoutValidation(
      event,
      payoutDataSchedule?.payoutScheduleLatest
    );
    if (hasNoError(validate)) {
      setErrorValdiation(validate);
      onSubmit(event);
    } else {
      setErrorValdiation(validate);
    }
  };

  return (
    <Form initial={initialForm} onSubmit={handleSubmit} confirmLeave>
      {({ data: formData, change, submit }) => (
        <Dialog onClose={onClose} open={open} maxWidth="sm" fullWidth>
          <>
            <DialogTitle>Payment Schedule</DialogTitle>
            <DialogContent ref={container}>
              <div className={classes.textBold}>
                <FormattedMessage
                  defaultMessage="Payout Period"
                  description="payout period"
                />
              </div>
              <Grid variant="repeated">
                <TextField
                  id="payoutStartDate"
                  className={classes.singleSelectField}
                  label={intl.formatMessage({
                    defaultMessage: "Start Date",
                    description: "select payout start date"
                  })}
                  type="date"
                  name="payoutStartDate"
                  onChange={event => {
                    handleSelectPayoutStartDate(event);
                    change(event);
                  }}
                  value={formData.payoutStartDate}
                  helperText={clientError?.payoutStartDate}
                  error={!!clientError?.payoutStartDate}
                  inputProps={{
                    min: Moment("2021-07-01").format("YYYY-MM-DD")
                  }}
                  InputLabelProps={{
                    shrink: true
                  }}
                />
                <TextField
                  id="payoutStartHour"
                  className={classes.singleSelectField}
                  label={intl.formatMessage({
                    defaultMessage: "Start Hour",
                    description: "select payout start hour"
                  })}
                  type="time"
                  name="payoutStartHour"
                  disabled={true}
                  onChange={event => {
                    handleSelectPayoutStartHour(event);
                    change(event);
                  }}
                  value={formData.payoutStartHour}
                  InputLabelProps={{
                    shrink: true
                  }}
                />
                <TextField
                  id="payoutEndDate"
                  className={classes.singleSelectField}
                  label={intl.formatMessage({
                    defaultMessage: "End Date",
                    description: "select payout end date"
                  })}
                  type="date"
                  name="payoutEndDate"
                  onChange={event => {
                    handleSelectPayoutEndDate(event);
                    change(event);
                  }}
                  value={formData.payoutEndDate}
                  helperText={clientError?.payoutEndDate}
                  error={!!clientError?.payoutEndDate}
                  inputProps={{
                    min: formData.payoutStartDate
                      ? formData.payoutStartDate
                      : Moment(new Date())
                          .add(1, "d")
                          .format("YYYY-MM-DD")
                  }}
                  InputLabelProps={{
                    color: "primary",
                    shrink: true
                  }}
                />
                <TextField
                  id="payoutEndHour"
                  className={classes.singleSelectField}
                  label={intl.formatMessage({
                    defaultMessage: "End Hour",
                    description: "select payout end hour"
                  })}
                  type="time"
                  name="payoutEndHour"
                  disabled={true}
                  onChange={event => {
                    handleSelectPayoutEndHour(event);
                    change(event);
                  }}
                  value={formData.payoutEndHour}
                  InputLabelProps={{
                    shrink: true
                  }}
                />
              </Grid>
              <div className={classes.textBold}>
                <FormattedMessage
                  defaultMessage="Payout Schedule"
                  description="payout schedule"
                />
              </div>
              <Grid variant="repeated">
                <TextField
                  id="scheduleDate"
                  className={classes.singleSelectField}
                  label={intl.formatMessage({
                    defaultMessage: "Schedule Date",
                    description: "select payout schedule date"
                  })}
                  type="date"
                  name="scheduleDate"
                  onChange={event => {
                    handleSelectScheduleDate(event);
                    change(event);
                  }}
                  value={formData.scheduleDate}
                  helperText={clientError?.scheduleDate}
                  error={!!clientError?.scheduleDate}
                  inputProps={{
                    min:
                      formData.payoutEndDate > today
                        ? Moment(formData.payoutEndDate)
                            .add(1, "d")
                            .format("YYYY-MM-DD")
                        : Moment(today)
                            .add(1, "d")
                            .format("YYYY-MM-DD")
                  }}
                  InputLabelProps={{
                    color: "primary",
                    shrink: true
                  }}
                />
                <TextField
                  id="scheduleTime"
                  className={classes.singleSelectField}
                  label={intl.formatMessage({
                    defaultMessage: "Schedule Hour",
                    description: "select payout schedule time"
                  })}
                  type="time"
                  name="scheduleTime"
                  disabled={true}
                  onChange={event => {
                    handleSelectScheduleTime(event);
                    change(event);
                  }}
                  value={formData.scheduleTime}
                  InputLabelProps={{
                    shrink: true
                  }}
                />
              </Grid>
            </DialogContent>
            <DialogActions className={classes.buttonActionFlex}>
              <div className={classes.buttonActions}>
                <Button
                  onClick={onClose}
                  variant="contained"
                  color="default"
                  className={classes.buttonWidth}
                >
                  BACK
                </Button>
                <Button
                  autoFocus
                  onClick={submit}
                  variant="contained"
                  color="primary"
                  className={classes.buttonWidth}
                >
                  SAVE
                </Button>
              </div>
            </DialogActions>
          </>
        </Dialog>
      )}
    </Form>
  );
};
PayoutScheduleDialog.displayName = "PayoutScheduleDialog";
export default PayoutScheduleDialog;
